module.exports = __webpack_public_path__ + "static/media/SelfieDoodle@3x.e1ebd3f9.png";